import BaseButton from "../base";
import { FunctionComponent, ReactNode } from "react";

export type BasicButtonType = {
  className?: string;
  label?: string;
  /** Variant props */
  size?: "lg" | "xl" | "md" | "sm";
  state?: "default" | "loading" | "disabled";
  style?: "primary" | "secondary" | "tertiary";
  width?: "hug content" | "fill container";
  color?:
    | "coral"
    | "black"
    | "white"
    | "blackWhite"
    | "whiteBlack"
    | "buy"
    | "sell"
    | "glacier";

  /** Custom Props  */
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const BasicButton: FunctionComponent<BasicButtonType> = ({
  className = "",
  label,
  iconLeft,
  iconRight,
  size = "md",
  state = "default",
  style = "primary",
  width = "hug content",
  color = "coral",
  onClick,
}) => {
  return (
    <BaseButton
      className={className}
      label={label}
      iconLeft={iconLeft}
      iconRight={iconRight}
      size={size}
      state={state}
      style={style}
      width={width}
      onClick={onClick}
      color={color}
    />
  );
};

BasicButton.displayName = "BasicButton";

export default BasicButton;
